/**
 * @generated SignedSource<<d28c39fd9eb42aa5778dab3ac8c0174c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ExpireRefreshTokenInput = {
  clientMutationId?: string | null;
  token: string;
};
export type CurrentUser_ExpireTokenMutation$variables = {
  input: ExpireRefreshTokenInput;
};
export type CurrentUser_ExpireTokenMutation$data = {
  readonly InfectopharmAuth: {
    readonly expireRefreshToken: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type CurrentUser_ExpireTokenMutation = {
  response: CurrentUser_ExpireTokenMutation$data;
  variables: CurrentUser_ExpireTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "InfectopharmAuthMutations",
    "kind": "LinkedField",
    "name": "InfectopharmAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ExpireRefreshTokenPayload",
        "kind": "LinkedField",
        "name": "expireRefreshToken",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CurrentUser_ExpireTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CurrentUser_ExpireTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "359439a1eccc9323718d0d64d0c6dd4d",
    "id": null,
    "metadata": {},
    "name": "CurrentUser_ExpireTokenMutation",
    "operationKind": "mutation",
    "text": "mutation CurrentUser_ExpireTokenMutation(\n  $input: ExpireRefreshTokenInput!\n) {\n  InfectopharmAuth {\n    expireRefreshToken(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e1fdeed21b7e257201b3266bb2d7d6a1";

export default node;
